// extracted by mini-css-extract-plugin
module.exports = {"signIn":"page_signIn___6b_t","column":"page_column__FyEdb","create":"page_create__O4RWd"};